import {BaseConnection} from './BaseConnection';

export class DatabaseConnection extends BaseConnection {
databaseKind: string;
databaseName: string;
}

